G.WorldSidePanelGroupContent = function(x, y) {
  Phaser.Group.call(this, game);
  this.position.setTo(x, y);

  this._eventManagers = [];

  // TODO: change initialization
  // so events can be added at any time
  this._ribbonEvent = null;
  this._noEventPanel = null;

  this._contentHeight = 0;

  this._dailyMissions = null;

  this._init();
};

G.WorldSidePanelGroupContent.prototype = Object.create(Phaser.Group.prototype);

G.WorldSidePanelGroupContent.prototype._init = function() {
  // imports
  var settings = G.json.settings;
  var saveState = G.saveState;
  var dailyMissionsMgr = G.dailyMissionsMgr;
  var DailyMissionContent = G.SPDailyMissionContent;
  var NoEventContent = G.WorldSidePanelNoEvent;
  var RibbonContent = G.OMTsettings.global.jungleMatch ? G.TitlePanel : G.WorldSidePanelRibbon ;

  // imports mgrs
  var treasureHuntMgr = G.TreasureHunt.treasureHuntMgr;
  var treasureHuntEventPanel = G.TreasureHunt.TreasureHuntEventPanel;

  this._addEventManager(treasureHuntMgr, treasureHuntEventPanel);

  var groupContent = this;

  this._ribbonEvent = this.add(new RibbonContent(0, 20, {
      ribbon: G.OMTsettings.global.jungleMatch ? "mission_title_panel" : "gold_wheel_ribbon",
      text: OMT.language.getText("Events"),
    }));

  this._noEventPanel = this.add(new NoEventContent());

  if (dailyMissionsMgr.isFeatureUnlocked()) {
    this._dailyMissions = this.add(new DailyMissionContent());
  }

  this._updateEventsView();
};

/**
 * @param manager {Object}
 * @param manager.onEventTurnedOnChange {Phaser.Signal<Boolean>}
 * @param manager.isEventTurnedOn {() => Boolean}
 * @param manager.isFeatureUnlocked {() => Boolean}
 * @param panelConstructor {() => {... Phaser.DisplayObject, getContentHeight: () => Number}}
 */
G.WorldSidePanelGroupContent.prototype._addEventManager = function(manager, panelConstructor, optPriority) {
  this._eventManagers.push({
    manager: manager,
    panelConstructor: panelConstructor,
    panelInstance: null,
    priority: G.Utils.defined(optPriority, 0),
  });

  G.Utils.cleanUpOnDestroy(this, 
    manager.onEventTurnedOnChange.add(this._updateEventsView, this));

  this._eventManagers
    .sort(function(a, b) {return b.priority - a.priority});
};

G.WorldSidePanelGroupContent.prototype._updateEventsView = function() {

  console.log("TH update event view");

  this._eventManagers.forEach(function(managerEntry) {
    var manager = managerEntry.manager;
    var panelInstance = managerEntry.panelInstance;

    if (manager.isEventTurnedOn()) {
      if (panelInstance === null) {
        managerEntry.panelInstance = new managerEntry.panelConstructor;
        this.add(managerEntry.panelInstance);

      }
    } else {
      if (panelInstance) {
        panelInstance.destroy();
        managerEntry.panelInstance = null;
      }
    }
  }, this);


  this._refreshElementsPlacement();
};


G.WorldSidePanelGroupContent.prototype.getContentHeight = function() {
  return this._contentHeight;
};

G.WorldSidePanelGroupContent.prototype._getContentElementsList = function() {
  var contentElements = [];

  var anyEventUnlocked = this._eventManagers.find(function(entry) {
    return entry.manager.isFeatureUnlocked();
  });
  var eventPanels = this._eventManagers
    .map(function(entry) {return entry.panelInstance})
    .filter(function (panelInstance) {return panelInstance})

  if (anyEventUnlocked) {
    contentElements.push(this._ribbonEvent);
    this._ribbonEvent.visible = true;
    if (eventPanels.length == 0) {
      this._noEventPanel.visible = true;
      contentElements.push(this._noEventPanel);
    } else {
      this._noEventPanel.visible = false;
      contentElements = contentElements.concat(eventPanels);
    }
  } else {
    this._noEventPanel.visible = false;
    this._ribbonEvent.visible = false;
  }

  if (this._dailyMissions) {
    contentElements.push(this._dailyMissions);
  }

  return contentElements;
};

G.WorldSidePanelGroupContent.prototype._refreshElementsPlacement = function() {
  var contentList = this._getContentElementsList();

  if (contentList.length == 0) return;

  var lastY = contentList[0].y;
  contentList.forEach(function(element, i) {
    element.x = 235;
    element.y = lastY;
    lastY += element.getContentHeight();
  });

  this._contentHeight = this._countContentHeight(contentList);
};

G.WorldSidePanelGroupContent.prototype._countContentHeight = function(contentList) {
  return contentList.reduce(function(acc, element) {
    return acc + element.getContentHeight();
  }, 0)
};
